export enum AvatarShape {
  Circle = 'Circle',
  Square = 'Square'
}
